import { makeObservable, observable } from 'mobx';
import LocalStorage from '../views/app/LocalStorage';
import { LangKey } from '../LangKey';

export type UnitAge = 'month' | 'year';
export type UnitSettings = { key: 'month', value: string } | { key: 'year', value: string };

export default class Settings {
  @observable
  unitAge: 'month' | 'year';
  allUnitAges: UnitSettings[] = [
    { key: 'month', value: LangKey.SettingsAgeUnitMonth },
    { key: 'year', value: LangKey.SettingsAgeUnitYear },
  ];

  private _localStorage: LocalStorage;

  constructor(localStorage: LocalStorage) {
    makeObservable(this);
    this._localStorage = localStorage;
    this.unitAge = this._localStorage.getValue('settingsUnitAge') as UnitAge ?? 'year';
  }

  unitAgeChange = (UnitAge: UnitAge): void => {
    this.unitAge = UnitAge;
    this._localStorage.setValue('settingsUnitAge', UnitAge);
  }
}
